import React from "react";

export const Not = (
    <g>
        <g fillRule="nonzero" fill="#000000" strokeOpacity="0" strokeWidth="1">
            <ellipse
                stroke="#000000"
                fill="#ffffff"
                cx="14.8971"
                cy="15.00973"
                id="svg_11"
                rx="12.61145"
                ry="12.40426"
            />
        </g>
        <g>
            <path d="M15,0C6.715,0,0,6.715,0,15c0,8.283,6.715,15,15,15c8.284,0,15-6.717,15-15C30,6.715,23.284,0,15,0z M15,27.273    C8.223,27.273,2.727,21.778,2.727,15C2.727,8.222,8.223,2.728,15,2.728c6.776,0,12.272,5.494,12.272,12.272    C27.272,21.778,21.776,27.273,15,27.273z" />
        </g>
        <g>
            <path d="M15,4.091C8.975,4.091,4.091,8.975,4.091,15c0,6.024,4.884,10.909,10.909,10.909c6.024,0,10.908-4.885,10.908-10.909    C25.908,8.975,21.024,4.091,15,4.091z M21.245,20.511l-0.735,0.735c-0.406,0.404-1.063,0.406-1.47,0l-4.042-4.041l-4.04,4.041    c-0.407,0.406-1.065,0.404-1.472,0l-0.733-0.735c-0.405-0.406-0.406-1.064,0-1.471L12.794,15l-4.04-4.04    c-0.406-0.407-0.406-1.065,0-1.471l0.733-0.735c0.406-0.404,1.064-0.407,1.471,0l4.04,4.041l4.042-4.041    c0.406-0.407,1.063-0.407,1.47,0l0.735,0.735c0.405,0.405,0.405,1.063,0,1.468L17.203,15l4.042,4.04    C21.651,19.447,21.65,20.106,21.245,20.511z" />
        </g>
    </g>
);
